import HomeSearch from '@/components/common/HomeSearch';
import HomeTypeTab from '@/components/common/HomeTypeTab';
import CategoryList from '@/features/Home/components/CategoryList';
import EventPopUpCarousel from '@/features/Home/components/common/EventPopUpCarousel';
import HomeBannerCarousel from '@/features/Home/components/common/HomeBannerCarousel';
import ReviewCarousel from '@/features/Home/components/common/ReviewCarousel';
import BestProductSection from '@/features/Home/components/sections/BestProductSection';
import GroundStorySection from '@/features/Home/components/sections/GroundStorySection';
import LocationPopularSection from '@/features/Home/components/sections/LocationPopularSection';
import NewProductSection from '@/features/Home/components/sections/NewProductSection';
import PlanningProductSection from '@/features/Home/components/sections/PlanningProductSection';
import RecentViewSection from '@/features/Home/components/sections/RecentViewSection';
import SpecialProductSection from '@/features/Home/components/sections/SpeciaProductSection';
import Top10ExperienceProductSection from '@/features/Home/components/sections/Top10ExperienceProductSection';
import WeekendSection from '@/features/Home/components/sections/WeekendSection';
import { useViewportStore } from '@/store/useViewportStore';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { styled } from 'styled-components';
const Home = () => {
  const router = useRouter();
  const isMobile = useViewportStore((store) => store.isMobile);

  const type = router.isReady && router.query.type === '마켓' ? 'market' : 'experience';
  return (
    <div>
      <HomeContainer>
        <ContentWrapper $isMobile={isMobile}>
          {isMobile && (
            <>
              <HomeSearch />
              <MobileBannerWrapper>
                <HomeBannerCarousel type={type} />
              </MobileBannerWrapper>
            </>
          )}
          {!isMobile && (
            <DesktopHeroSection>
              <DesktopBannerWrapper>
                <HomeBannerCarousel type={type} />
              </DesktopBannerWrapper>
              <HomeTypeTab />
              <CategoryList />
              <DesktopAroundMeLink href="/around-me">내 주변 지도에서 보기</DesktopAroundMeLink>
              <DesktopShortcutRow>
                <DesktopShortcutLink href="/category/coupon">
                  <img src="/icons/coupon-btn.png" width={16} height={16} alt="coupon" />
                  이달의 쿠폰
                </DesktopShortcutLink>
                <DesktopShortcutLink href="/story">
                  <img src="/icons/story-btn.png" width={16} height={16} alt="story" />
                  스토리
                </DesktopShortcutLink>
              </DesktopShortcutRow>
            </DesktopHeroSection>
          )}
          {isMobile && (
            <>
              <HomeTypeTab />
              <CategoryList />
            </>
          )}
          {isMobile && (
            <ShortcutButtonRow>
              <ShortcutLink href="/category/coupon">
                <img src="/icons/coupon-btn.png" width={16} height={16} alt="쿠폰" />
                이달의 쿠폰
              </ShortcutLink>
              <ShortcutLink href="/story">
                <img src="/icons/story-btn.png" width={16} height={16} alt="스토리" />
                스토리
              </ShortcutLink>
            </ShortcutButtonRow>
          )}
          {type === 'experience' && (
            <>
              <Top10ExperienceProductSection />
              <LocationPopularSection />
              <WeekendSection />
              <GroundStorySection />
              <RecentViewSection />
            </>
          )}

          {type === 'market' && (
            <>
              <PlanningProductSection />
              <BestProductSection />
              <SpecialProductSection />
              <NewProductSection />
              <ReviewCarousel />
            </>
          )}
        </ContentWrapper>
      </HomeContainer>
      <EventPopUpCarousel />
    </div>
  );
};

export default Home;

const HomeContainer = styled.div`
  margin: 0 auto;
`;

const ContentWrapper = styled.div<{ $isMobile: boolean }>`
  margin-top: ${({ $isMobile }) => ($isMobile ? '4px' : '18px')};
`;

const DesktopHeroSection = styled.section`
  margin-bottom: 72px;
`;

const DesktopBannerWrapper = styled.div`
  overflow: hidden;
  margin-bottom: 28px;
  background: ${({ theme }) => theme.colors.white};
`;

const DesktopAroundMeLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 54px;
  margin: 0;
  padding: 0 32px;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: 10px;
  background: #f2f3f7;
  color: ${({ theme }) => theme.colors.gray1000};
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  text-decoration: none;

  &::after {
    content: '>';
    margin-left: 12px;
    font-size: 14px;
    line-height: 1;
  }
`;

const DesktopShortcutRow = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
  margin-top: 12px;
`;

const DesktopShortcutLink = styled(Link)`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 48px;
  box-sizing: border-box;
  padding: 10px 14px;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
`;

const MobileBannerWrapper = styled.div`
  margin: 8px 0 12px;
`;

const ShortcutButtonRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 100px;
`;

const ShortcutLink = styled(Link)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 16px;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
  text-decoration: none;
`;
